const styles = theme => ({
	root: {
		display: 'flex',
	},

	moveIcon: {
		color: '#009AC9',
		cursor: 'pointer',
		paddingLeft: 6,
	},

	removeIcon: {
		color: '#f50057',
		cursor: 'pointer',
		paddingLeft: 6,
	},

	disabledIcon: {
		color: '#C5C5C5',
		cursor: 'default',
	},
	
	row: {
		padding: '0',
	},

	assignButton: {
		boxShadow: 'none',
		height: '21px',
		minWidth: '65px',
	},
});

export default styles;